import { E } from "@scripts/fp-ts";
import * as p from "@scripts/generated/domaintables/pages";
import { relatedIssuersMeta } from "@scripts/meta/dataMeta";
import { SitesJumpLink } from "@scripts/react/components/SidebarLinks";

export const relatedIssuers = SitesJumpLink(relatedIssuersMeta, [E.right(p.relatedIssuers)]);
